angular.module('List').directive('tabNavigation', function() {
   return {
       restrict: 'E',
       scope: {
           location: '='
       },
       templateUrl: templatePath+'directiveTabNavigation.html'
   }
});
